// extracted by mini-css-extract-plugin
export default {"listItem":"CommercialPoint-listItem_BGbYe"};